import React from 'react';

import NewPlatformInfoPage from '../components/NewPlatformInfoPage';

const NewPlatform = () => (
  <NewPlatformInfoPage
    lang="es"
    title="Full Stack Open se está trasladando a una nueva plataforma | Full Stack open"
  />
);

export default NewPlatform;
